<template>
  <div class="gwnl-eval-evaluator__row">
    <yxt-tooltip :content="evaluatorLevel" placement="top" open-filter>
      <span class="color-gray-7 lh-50 mr24 yxtbiz-flex-shrink-0 ellipsis max-width-100">{{ evaluatorLevel }}</span>
    </yxt-tooltip>

    <span v-if="showWeight" class="color-gray-10 lh-50 mr24 yxtbiz-flex-shrink-0 min-width30">
      {{ `${relation.weight}%` }}
    </span>
    <yxt-button
      plain
      :disabled="row.selectDisable || false"
      class="mr16 shrink0"
      @click="selectPersonnel"
    >
      {{ $t('pc_gwnl_eval_selectPersonnel') }}
    </yxt-button>
    <span
      v-if="!validate && validateError"
      class="color-fa5252 font-size-12 lh-50"
    >
      {{ $t('pc_gwnl_eval_pleaseSelectPersonnel') }}
    </span>
    <div
      v-if="relation.evaluators.length > 0"
      class="mt8 lh-normal"
    >
      <yxt-tag
        v-for="tag in evaluatorDisplay"
        :key="tag.id"
        class="mr8 mb8"
        size="small"
        type="info"
        :closable="!row.selectDisable"
        @close="deleteEvaluator(tag)"
      >
        <yxt-popover
          placement="top"
          trigger="hover"
          :max-width="300"
          :open-filter="true"
          :content="tag.fullname"
        >
          <div
            slot="reference"
            class="yxtbiz-user-selector-tag max-width-62"
          >
            <yxtbiz-user-name :name="tag.fullname || tag.fullName" />
          </div>
        </yxt-popover>
      </yxt-tag>
      <yxt-tag
        v-show="relation.evaluators.length>20"
        class="mr8 mb8 hand"
        size="small"
        type="info"
        @click="handleExpandTag"
      >
        <span class="mr8">{{ toExpand?$t('pc_eval_web_up_more' /*展开更多*/):$t('pc_gwnl_clamp_retract' /*收起*/) }}</span>
        <i :class="toExpand?'yxt-icon-arrow-down':'yxt-icon-arrow-up'" />
      </yxt-tag>
      <div
        v-if="relation.evaluators.length > 200"
        class="color-fa5252 font-size-12 lh-50"
      >
        {{ $t('pc_eval_uptoMaxAddPerson',[200] /*最多可添加200个评估人*/) }}
      </div>
    </div>
    <yxtbiz-eval-select-user
      ref="selector"
      :visible.sync="dialogVisible"
      :function-code="functionCode"
      :data="evaluators"
      :data-permission-code="dataPermissionCode"
      @getUsers="getUsers"
    >
    <div slot="title">
      <span>{{ $t('pc_gwnl_eval_btn_addTesters') }}</span>
    </div>
    </yxtbiz-eval-select-user>
  </div>
</template>
<script>
import { addEvalUserRelation, deleteEvalRelationUsers, addEvalUserRelationDynamic, deleteEvalRelationUsersDynamic } from './service';
import evalPager from '../../eval-create-drawer/src/components/eval-pager';
import evalSelectUser from '../../eval-create-drawer/src/components/eval-select-user';
const RELATIONTYPES = [
  { key: 'leaderRelation', type: '2', label: 'pc_gwnl_chart_type_leaderLevel' },
  { key: 'equalRelation', type: '3', label: 'pc_gwnl_chart_type_equalLevel' },
  { key: 'subordinateRelation', type: '4', label: 'pc_gwnl_chart_type_subordinateLevel' }
];
export default {
  components: {
    yxtbizEvalPager: evalPager,
    yxtbizEvalSelectUser: evalSelectUser
  },
  props: {
    row: Object,
    validate: {
      type: Boolean,
      default: false
    },
    isSave: { // 是否需要落库保存
      type: Boolean,
      default: false
    },
    relation: {
      type: Object,
      default: () => {
        return {
          type: 2,
          weight: 0,
          evaluators: []
        };
      }
    },
    showWeight: {
      type: Boolean,
      default: true
    },
    dataPermissionCode: {
      type: String,
      default: 'gwdt_eval_tools_addassessor_extent'
    },
    functionCode: {
      type: String,
      default: 'gwnl_model_position'
    },
    id: {
      type: String,
      default: ''
    },
    dynamicChoose: {
      type: Number,
      default: 0 // 默认胜任力测评
    }
  },
  data() {
    return {
      RELATIONTYPES,
      dialogVisible: false,
      tabs: ['persons'],
      evaluators: [],
      toExpand: true
    };
  },
  computed: {
    validateError() {
      let validateError = false;
      this.RELATIONTYPES.forEach(relationType => {
        if (this.row[relationType.key]) {
          validateError = true;
        }
      });
      this.RELATIONTYPES.forEach(relationType => {
        if (this.row[relationType.key]) {
          if (this.row[relationType.key].evaluators && this.row[relationType.key].evaluators.length) {
            validateError = false;
          }
        }
      });
      return validateError;
    },
    evaluatorLevel() {
      switch (this.relation.type) {
        case '1':
          return this.$t('pc_gwnl_chart_type_selfLevel');
        case '2':
          return this.$t('pc_gwnl_chart_type_leaderLevel');
        case '3':
          return this.$t('pc_gwnl_chart_type_equalLevel');
        case '4':
          return this.$t('pc_gwnl_chart_type_subordinateLevel');
        default:
          return this.relation.dimensionName;
      }
    },
    // 测评评估人数超20时仅展示前20条数据
    evaluatorDisplay() {
      let evaluatorData;
      if (this.relation.evaluators.length > 20 && this.toExpand) {
        let evaluatorCopy = JSON.parse(JSON.stringify(this.relation.evaluators));
        evaluatorData = evaluatorCopy.splice(0, 20);
      } else {
        evaluatorData = this.relation.evaluators;
      }
      return evaluatorData;
    }
  },
  watch: {
    'relation.evaluators': {
      handler() {
        this.handleEvaluators();
      },
      immediate: true,
      deep: true
    }
  },

  created() {
    const keysList = this.RELATIONTYPES.map(item => item.key);
    // 为了比较是否有相同评估人的时候把自定义评估关系带着
    (this.row.customRelation || []).forEach(item => {
      item.weight && !keysList.includes(item.type) && this.RELATIONTYPES.push({
        key: item.type,
        type: item.type,
        label: item.dimensionName
      });
    });
  },

  methods: {
    // 公共删除单个和清空所有人员的方法
    async clearAndDelEvaluator(evaluators, callback) {
      try {
        if (this.isSave) {
          if (this.dynamicChoose) {
            await deleteEvalRelationUsersDynamic(this.id, {
              evalUserId: this.row.id,
              evaluatorIds: evaluators,
              type: this.relation.type
            });
          } else {
            await deleteEvalRelationUsers(this.id, {
              evalUserId: this.row.id,
              evaluatorIds: evaluators,
              type: this.relation.type
            });
          }
        }

        callback && callback();
      } catch (err) {
        this.$message.error(err.error.message);
      }
    },

    // 统一去更新评估人的方法
    updateRowEvaluators(val) {
      this.$nextTick(() => {
        this.$emit('update-evaluate', { rowId: this.row.id, val });
      });
    },

    deleteEvaluator(tag) {
      if (!tag.id) return;

      // 如果是保存状态，则调用删除关系用户的异步方法
      this.clearAndDelEvaluator([tag.id], () => {
        // 过滤掉需要删除的评估员
        const filterEval = this.relation.evaluators.filter((evaluator) => evaluator.id !== tag.id);
        this.updateRowEvaluators(filterEval);
      });
    },
    async getUsers(users) {
      // 评估人为空的时候更新数据
      if (!users.length) {
        const ids = (this.evaluators || []).map(item => item.id);
        this.clearAndDelEvaluator(ids, () => {
          this.updateRowEvaluators([]);
          this.dialogVisible = false;
        });
        return;
      }

      // 评估人不能超过200个
      if (users.length > 200) {
        this.$message.error(this.$t('pc_eval_uptoMaxAddPerson', [200] /* 最多可添加200个评估人 */));
        return false;
      }
      // 检验是否选择被评估人作为评估人
      let selfFlag = users.some(item => item.id === this.row.userId);
      if (selfFlag) {
        this.$message.error(this.$t('pc_gwnl_eval_msg_dontSelectEvaluatorHimself', { evaluatorLevel: this.evaluatorLevel }));
        return false;
      }

      // 集合所有的人和对应的id关系
      const otherIds = {};
      RELATIONTYPES.forEach(item => {
        // 当前是否存在对应评估人 & 排除自身的人员
        if (this.row[item.key] && this.row[item.key].evaluators && this.row[item.key].evaluators.length && this.relation.type !== item.type) {
          this.row[item.key].evaluators.forEach(user => {
            otherIds[user.id] = this.$t(item.label);
          });
        }
      });

      const choosedList = users
        .filter(item => otherIds[item.id])
        .map(item => otherIds[item.id]);

      if (choosedList && choosedList.length) {
        const uniqueChoosedList = Array.from(new Set(choosedList));
        const msg = this.$t('pc_gwnl_eval_msg_dontSelect') + uniqueChoosedList.join('、') + this.$t('pc_gwnl_eval_msg_evaluatorAsLevelEvaluator', { evaluatorLevel: this.evaluatorLevel });
        this.$message.error(msg);
        return false;
      }

      const evaluatorIds = users.map(item => item.id) || [];
      if (evaluatorIds.length) { // 更新评估人列表
        const EVALUATOR_TYPE = 'person';
        const evaluators = users.map(({ id, fullname, name }) => ({
          id,
          fullname: fullname || name,
          type: EVALUATOR_TYPE
        }));

        try {
          if (this.isSave) {
            if (this.dynamicChoose) {
              await addEvalUserRelationDynamic(this.id, {
                evalUserId: this.row.id,
                evaluatorIds,
                type: this.relation.type
              });
            } else {
              await addEvalUserRelation(this.id, {
                evalUserId: this.row.id,
                evaluatorIds,
                type: this.relation.type
              });
            }

            let unchosenPerson = this.findDeselectedItem(users.map(item => item.id), this.relation.evaluators);

            if (unchosenPerson.length > 0) {
              const unChooseIds = unchosenPerson.map(item => item.id);
              this.clearAndDelEvaluator(unChooseIds);
            }
          }

          // 添加人员
          this.updateRowEvaluators(evaluators);
        } catch (err) {
          this.$message.error(err.error.message);
        }
      }
      this.dialogVisible = false;
    },
    findDeselectedItem(CurrentArray, PreviousArray) {
      const cancelSelect = PreviousArray.filter(item => !CurrentArray.includes(item.id));
      return cancelSelect;
    },
    beforeDrawClose(done) {
      done();
    },
    handleEvaluators() {
      this.evaluators = this.relation.evaluators.map((item) => {
        return {
          name: item.fullname || item.userName,
          id: item.id || item.userId,
          fullname: item.fullname || item.fullName,
          type: 'person'
        };
      });
    },
    selectPersonnel() {
      this.dialogVisible = true;
    },
    // 展开更多及收起的内容切换
    handleExpandTag() {
      this.toExpand = !this.toExpand;
    }
  }
};
</script>

<style lang='scss' scoped>
.gwnl-eval-evaluator__row {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e9e9e9;
  .lh-50 {
    line-height: 50px;
  }
  .min-width30 {
    min-width: 30px;
  }
}

.color-fa5252 {
  color: #fa5252;
}

.w42 {
  width: 42px;
}

.max-width-62 {
  max-width: 62px;
}
</style>
